import SelectMultipleEditable from "../../../components/selectMultipleEditable";
// import Close from "../../../components/icons/close";

export default function SecurityFilterDropdown ({securityDropdownOptions, selectedTickers, onChange, onClear }) {
  const allSelected = selectedTickers.length === securityDropdownOptions.length;

  const itemsSelected = securityDropdownOptions.filter((s) =>
    selectedTickers.includes(s.id)
  ).map((s) => ({
    id: s.id,
    value: s.value,
  }));

  const chipText = allSelected
    ? `Todas las securities (${securityDropdownOptions.length})`
    : `${selectedTickers.length} de ${securityDropdownOptions.length} securities`;

  const handleGetOptions = (items) => {
    if (Array.isArray(items) && items.length > 0) {
      onChange(items.map((item) => item.id));
    }
  };

  return (
    <div className="c-tax-harvesting-security">
      <span className="c-tax-harvesting-security__label">SECURITY</span>

      <div className="c-tax-harvesting-security__control">

        <div className="c-tax-harvesting-security__select">
          <SelectMultipleEditable
            setRef={() => {}}
            openOptions={() => {}}
            getOptions={(selectedItems) => handleGetOptions(selectedItems)}
            defaultValue=""
            itemsSelected={itemsSelected}
            multiple={true}
            colorGrey={true}
            options={securityDropdownOptions}
          />

          <span className="c-tax-harvesting-security__chip-text">{chipText}</span>


          {selectedTickers.length > 0 && (
            <div className="c-tax-harvesting-security__select-clean-selected">
              <button
                type="button"
                className="c-tax-harvesting-security__chip-clear"
                onClick={() =>
                  onClear
                    ? onClear()
                    : onChange([selectedTickers[selectedTickers.length - 1]])
                }
                aria-label="Limpiar selección"
              >
            
                <span className="c-tax-harvesting-security__chip-select-all">Deseleccionar todas</span>
                {/* <Close width={12} height={12} /> */}
              </button>
            </div>
          )}


          <button
            type="button"
            className="c-tax-harvesting-security__chip-select-all"
            onClick={() => onChange(securityDropdownOptions.map((s) => s.id))}
          >
            Seleccionar todas
          </button>
        </div>
      </div>
    </div>
  );
};
